import Vue from 'vue'

import VueI18n from "vue-i18n";

const supportedLanguages = ["de", "en"];

function replaceLangDataWithX(obj, lang) {
  for (let key in obj) {
    let val = obj[key]
    // console.log(key, val)
    if (typeof val == 'string') {
      obj[key] = '[' + lang + ': ' + key + ']'
    } else if (typeof val == 'object') {
      obj[key] = replaceLangDataWithX(val, lang)
    }
  }
  return obj
}

const loadBundles = () =>
  supportedLanguages.reduce((obj, lang) => {
    var langData = require(`../i18n/${lang}.json`);
    // Doesnt work with router (query not initialized yet)
    if (window.location.search && window.location.search.indexOf('langx=1') != -1) {
      console.log('replacing language data')
      replaceLangDataWithX(langData, lang);
    }
    obj[lang] = langData
    return obj
  }, {})

Vue.use(VueI18n);

export const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: "de",
  fallbackLocale: {
    // 'zh-Hant':   ['zh-Hans'],
    'default': ['en', 'de']
  },
  messages: loadBundles()
});

i18n.locale = navigator.language

export default i18n
